import { createApi } from 'api/common/createApi'
import config, { API_TYPES } from 'constants/app-config'

export const experienceBuilderApi = createApi({
  baseURL: config[API_TYPES.MT_API_URL],
})

export const facadeApi = createApi({
  baseURL: '/api',
})
